module.exports = __webpack_public_path__ + "static/media/agents-phone.28bf52ab.png";